<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <ul class="breadcrumb">
      <li class="breadcrumb-item bcrumb-1">
        <a [routerLink]="'/dashboard'">
          <i class="fas fa-home"></i>
        </a>
      </li>
      <ng-container *ngFor="let item of items">
        <li class="breadcrumb-item">
          <a *ngIf="item.link; else boldText" [routerLink]="item.link">{{ item.label }}</a>
          <ng-template #boldText>
            <strong>{{ item.label }}</strong>
          </ng-template>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
